import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('tr-TR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('tr-TR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY'
  }).format(amount);
}

export const appointmentTypes = {
  wedding: 'Düğün',
  shooting: 'Çekim',
  pre_meeting: 'Ön Görüşme',
  engagement: 'Nişan'
};

export const appointmentStatuses = {
  planned: 'Planlandı',
  in_progress: 'Devam Ediyor',
  completed: 'Tamamlandı',
  cancelled: 'İptal Edildi'
};

export const shootTypes = {
  photo: 'Fotoğraf',
  video: 'Video',
  drone: 'Drone',
  all: 'Hepsi'
};

export const shootStatuses = {
  planned: 'Planlandı',
  shooting: 'Çekimde',
  editing: 'Düzenleniyor',
  delivered: 'Teslim Edildi'
};

export const teamRoles = {
  photographer: 'Fotoğrafçı',
  videographer: 'Kameraman',
  drone_operator: 'Drone Operatörü',
  assistant: 'Asistan'
};

export const notificationChannels = {
  sms: 'SMS',
  whatsapp: 'WhatsApp',
  email: 'E-posta'
};
